import React, { useEffect, useState } from "react";
import "./WelcomeCard.css";
import { ReactComponent as Logo } from "../../assets/icons/login/Logo.svg";

const WelcomeCard = ({ text, customClass }) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className={`WelcomeCard ${customClass}`}>
      <h3>{text}</h3>
      <Logo />
    </div>
  );
};

export default WelcomeCard;
